// import { LAMBDA_API_URL } from "src/utils";
import { client } from "src/services/client";

export const fetchCommunity = async () =>
    client({
        method: "get",
        url: `/bayview`,
        baseURL: "https://g6h7cwzynd.execute-api.us-east-1.amazonaws.com/",
    }).then((response) => response.data);
